import { Box, Skeleton } from "@mui/material";

export default function CreateApiKeyFormSkeleton() {
    return (
        Array.from({ length: 5 }).map((_, index) => (
            <Box key={index} display='flex' alignItems='center' gap={2} py={0.5}>
                <Skeleton
                    variant="rectangular"
                    width={18}
                    height={18}
                    animation="wave"
                    sx={{
                        borderRadius: 0.5,
                        bgcolor: 'skeleton'
                    }}
                />
                <Skeleton
                    variant="text"
                    width={120}
                    height={20}
                    animation="wave"
                    sx={{
                        bgcolor: 'skeleton'
                    }}
                />
            </Box>
        ))
    )
}